<template>
  <v-navigation-drawer
    v-model="internalDialog"
    right
    class="navigation-drawer"
    width="400"
    persistent
    :fullscreen="$vuetify.breakpoint.xsAndDown"
  >
    <template v-slot:prepend>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close"> mdi-close </v-icon>
      </v-toolbar>
    </template>

    <v-card class="document-viewer">
      <v-card-text class="document-content">
        <v-img
          :src="invoiceImg"
          :aspect-ratio="null"
          class="document-image"
          v-if="invoiceImg"
        ></v-img>
        <div v-else class="text-center pa-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-2">{{ loadingMessage }}</p>
        </div>

        <!-- Overlay de procesamiento DIAN -->
        <v-overlay v-model="showDianProcessing" absolute color="primary" opacity="0.8">
          <div class="text-center">
            <v-progress-circular
              indeterminate
              color="white"
              size="64"
            ></v-progress-circular>
            <h3 class="white--text mt-4">{{ dianProcessingMessage }}</h3>
            <p class="white--text mt-2">Por favor espere...</p>
          </div>
        </v-overlay>
      </v-card-text>
    </v-card>

    <template v-slot:append>
      <v-toolbar class="fixed-footer">
        <v-speed-dial
          v-model="fab"
          direction="top"
          open-on-clic
          transition="slide-y-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="info" dark> Opciones </v-btn>
          </template>
          <InvoicePDFGenerator :documentData="item" :isPurchaseOrder="pdfGenerator" />

          <template
            v-if="
              item && item.document && ['FE', 'FC', 'NC'].includes(item.document.doc_type)
            "
          >
            <!-- Reenviar Correo -->
            <v-btn
              color="info"
              class="pl-2 pr-2 mr-2"
              @click="send_invoice(item.document.cufe)"
              small
              dark
              v-if="item.document.cufe && item.buyer && item.buyer.PartyEmail"
              :loading="loading_mail"
              title="Reenviar Factura por Correo"
            >
              <v-icon small>mdi-email-send</v-icon>
              <span class="ml-1">Reenviar Email</span>
            </v-btn>

            <!-- Reenviar Contingencia -->
            <v-btn
              color="success"
              class="pl-2 pr-2 mr-2"
              @click="resendToDIAN()"
              small
              dark
              v-if="item.document.doc_type === 'FC' && item.document.invoice"
              :loading="loading_status"
              title="Reenviar Factura de Contingencia a DIAN"
            >
              <v-icon small>mdi-send-check</v-icon>
              <span class="ml-1">Reenviar Contingencia</span>
            </v-btn>

            <v-btn
              color="success"
              class="pl-2 pr-2 mr-2"
              @click="processToDIAN()"
              small
              dark
              v-if="item.document.doc_type === 'FC' && !item.document.invoice"
              :loading="loading_status"
              title="Procesar Factura de Contingencia a DIAN"
            >
              <v-icon small>mdi-send-check</v-icon>
              <span class="ml-1">Procesar Contingencia</span>
            </v-btn>
            <!-- Reenviar Factura Electrónica -->
            <v-btn
              color="blue"
              class="pl-2 pr-2 mr-2"
              @click="resendToDIAN()"
              small
              v-if="item.document.doc_type === 'FE'"
              :loading="loading_status"
              title="Reenviar Factura Electrónica a DIAN"
            >
              <v-icon small>mdi-send</v-icon>
              <span class="ml-1">Reenviar DIAN</span>
            </v-btn>

            <!-- Enviar Nota de Crédito -->
            <v-btn
              color="warning"
              class="pl-2 pr-2 mr-2"
              @click="e_credit_note(item)"
              small
            >
              <v-icon small>mdi-note-edit</v-icon>
              <span class="ml-1">Enviar NC</span>
            </v-btn>
            <v-btn
              color="warning"
              @click="edit_nc()"
              v-if="
                item && item.document && ['FE', 'FC'].includes(item.document.doc_type)
              "
            >
              Nota Crédito
            </v-btn>
          </template>
        </v-speed-dial>
        <v-spacer></v-spacer>

        <v-btn color="info" class="pl-2 pr-2" @click="print_doc()"> Imprimir </v-btn>
      </v-toolbar>
    </template>

    <v-dialog
      v-model="nc_dialog"
      transition="dialog-fade-transition"
      scrollable
      max-width="650"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card class="mx-auto">
        <v-card-title class="pa-0">
          <v-toolbar dark color="pink darken-3">
            Nota Crédito - {{ item && item.document ? item.document.doc_number : "" }}
            <v-spacer></v-spacer>
            <v-icon @click="nc_dialog = !nc_dialog"> mdi-close </v-icon>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-0 pt-4">
          <v-data-table
            v-model="selected"
            :headers="headers_nc"
            :items="nc_items"
            :items-per-page="-1"
            class="elevation-1"
            calculate-widths
            mobile-breakpoint="0"
            :loading="loading_status"
            loader-height="10"
            loading-text="Cargando ..."
            hide-default-footer
            show-select
          >
            <template v-slot:[`item.cantidad`]="{ item }">
              <v-btn fab icon @click="editItem(item)">
                {{ item.cantidad }}
              </v-btn>
            </template>
            <template v-slot:[`item.refe`]="{ item }">
              {{
                item.categoria +
                "-" +
                item.marca +
                "-" +
                item.refe +
                "-" +
                item.color +
                "-" +
                item.talla
              }}
            </template>
            <template v-slot:[`item.precio`]="{ item }">
              {{ "$ " + (item.precio * item.cantidad).toLocaleString(2) }}
              <br />
              <small
                class="red--text text-decoration-line-through"
                v-if="item.discount > 0"
                >{{
                  "$ " + ((item.discount + item.precio) * item.cantidad).toLocaleString(2)
                }}
              </small>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-toolbar>
            <v-spacer></v-spacer>
            <v-btn @click="create_nc" v-if="selected.length > 0">
              Crear Nota Crédito
            </v-btn>
          </v-toolbar>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="nc_success" :timeout="2000" color="success">
      NC Regsitrada con exito.
    </v-snackbar>
  </v-navigation-drawer>
</template>

<script>
import { fe_ws, formatCurrency, webserver } from "@/services/webserver.js";
import createDoc from "@/utils/create_doc.js";
import settings from "@/utils/settings.js";
import createCompany from "@/utils/createCompany.js";
import InvoicePDFGenerator from "@/components/InvoicePDFGenerator.vue";
import CryptoJS from "crypto-js";
import DIANService from "@/services/DIANService.js";
import { generateColombiaPrint } from "@/utils/printers/colombiaPrintGenerator.js";
import { resolveDianDocTypeId } from "@/utils/dianDocTypes.js";

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: createDoc(),
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    newInvoice: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { InvoicePDFGenerator },
  mounted() {
    this.internalDialog = this.dialog;
    // Validar que existan los datos necesarios antes de cargar empresa
    if (this.item && this.item.document && window.store) {
      this.get_company();
    } else {
      console.warn("⚠️ Doc viewer: Faltan datos para cargar empresa", {
        hasItem: !!this.item,
        hasDocument: !!(this.item && this.item.document),
        hasStore: !!window.store,
      });
    }
  },
  data() {
    const settingsData = settings();
    return {
      nc_success: false,
      pdfGenerator: true,
      internalDialog: this.dialog,
      fab: false,
      nc_dialog: false,
      nc_items: [],
      loading_mail: false,
      dialog_mail: false,
      mail_response: {},
      headers_nc: [
        {
          text: "Descripción",
          align: "start",
          sortable: true,
          value: "item_concept",
          dataType: "text",
        },
        {
          text: "Qty",
          align: "center",
          sortable: true,
          value: "item_quantity",
          dataType: "text",
          width: "10",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "item_price",
          dataType: "number",
        },
        { text: "", align: "end", value: "actions", sortable: false, width: "5" },
      ],
      selected: [],
      invoiceImg: null,
      urlCufe: null,
      dian_dialog: false,

      docview: "",
      loading_status: false,
      loadingMessage: "Generando documento...",
      company: createCompany(),
      id_lst: settingsData["type_document_identifications"] || [],
      settings: settings(),
      dialog_erros: false,
      currentPrinter: null, // Referencia a la impresora actual
      imageSrc: null, // Para almacenar la imagen generada
      showDianProcessing: false,
      dianProcessingMessage: "Procesando con DIAN...",
    };
  },
  methods: {
    formatCurrency,

    formatAmount(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    get_name_typeId(e) {
      var index = this.id_lst.findIndex((itm) => itm.code === e);
      if (index >= 0) {
        return this.id_lst[index].name;
      } else {
        return "";
      }
    },

    // Método unificado para seleccionar formato de impresión
    selectPrintFormat() {
      if (!this.item || !this.item.document) {
        console.warn("No hay datos de documento para imprimir");
        return;
      }
      console.log("doc_type", this.item.document.doc_type);
      this.print_invoice(false);
    },

    print_invoice(printer) {
      if (!this.item || !this.item.document) {
        console.warn("No hay datos de documento para imprimir");
        return;
      }

      try {
        // 🇨🇴 Decidir qué impresora usar
        const isColombiaDocument = this.isColombianDocument();

        if (isColombiaDocument) {
          console.log("🇨🇴 Usando impresora colombiana para documento DIAN");
          this.useColombianPrinter(printer);
        } else {
          console.log("🌍 Usando impresora genérica");
          this.useGenericPrinter(printer);
        }
      } catch (error) {
        console.error("Error en print_invoice:", error);
      }
    },

    // 🇨🇴 Usar impresora colombiana (placeholder)
    useColombianPrinter(printer) {
      console.log("useColombianPrinter - usando imagen ya generada");
      // La imagen ya fue generada en el watcher
      if (printer && this.invoiceImg) {
        this.print_doc();
      }
    },

    // 🌍 Usar impresora genérica (formato original)
    useGenericPrinter() {
      // Aquí iría la lógica original del print_invoice
      console.log("Generando documento con formato genérico");
      // Para simplificar, por ahora mostraremos un placeholder
      this.invoiceImg =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";
    },

    // 🔍 Detectar si es documento colombiano
    isColombianDocument() {
      // Verificar por país de la compañía
      if (
        this.item?.company?.country === "CO" ||
        this.item?.company?.country === "Colombia"
      ) {
        return true;
      }

      // Verificar por tipo de documento DIAN
      const colombianDocTypes = ["FE", "FC", "NC", "pos", "invoice", "invoiceC"];
      if (colombianDocTypes.includes(this.item?.document?.doc_type)) {
        return true;
      }

      // Verificar si tiene datos específicos de Colombia
      if (this.item?.seller?.TaxLevelCode || this.item?.permit?.InvoiceAuthorization) {
        return true;
      }

      return false;
    },

    encryptId(id) {
      const key = "AiP05KeyAiP05KeyAiP05KeyAiP05Key";
      try {
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(id, CryptoJS.enc.Utf8.parse(key), {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const hmac = CryptoJS.HmacSHA256(
          encrypted.ciphertext,
          CryptoJS.enc.Utf8.parse(key)
        );
        const result = iv.concat(hmac).concat(encrypted.ciphertext);
        return encodeURIComponent(btoa(CryptoJS.enc.Latin1.stringify(result)));
      } catch (error) {
        console.error("Error al encriptar:", error);
        throw new Error("No se pudo encriptar el ID del documento");
      }
    },

    close() {
      this.internalDialog = false;
      this.$emit("close");
    },

    edit_nc() {
      if (!this.item || !this.item.document) {
        console.warn("No hay datos de documento para editar nota de crédito");
        return;
      }
      console.log("edit_nc", this.item);
      this.nc_items = this.item.items;
      this.nc_dialog = true;
    },

    get_company() {
      // Validar que existan los datos necesarios antes de hacer la consulta
      if (!window.store || !window.store.store_id || !window.store.store_business_id) {
        // console.warn("No hay datos de tienda disponibles para consultar la empresa");
        this.loading_status = false;
        return;
      }

      // Validar que store_id no esté vacío o undefined
      if (!window.store.store_id || window.store.store_id.trim() === "") {
        console.error(
          "❌ Error: store_id está vacío o undefined:",
          window.store.store_id
        );
        this.loading_status = false;
        return;
      }

      var qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [
          {
            field: "store_code",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "PartyIdentification",
            operator: "=",
            value: window.store.store_business_id,
          },
        ],
      };

      // console.log("🔍 Enviando query get_company:", qry);

      this.loading_status = true;

      webserver(
        "get_dataTable",
        qry,
        (data) => {
          this.loading_status = false;
          try {
            if (data && Array.isArray(data) && data.length > 0) {
              this.company = data[0];
              // console.log("✅ Empresa cargada:", this.company.PartyName);
            } else {
              console.warn("⚠️ No se encontraron datos de empresa");
              // Mantener la empresa por defecto del createCompany()
            }
          } catch (error) {
            console.error("❌ Error procesando datos de empresa:", error);
          }
        },
        (error) => {
          // Callback de error agregado
          this.loading_status = false;
          console.error("❌ Error en consulta get_company:", error);
          // Mantener la empresa por defecto
        }
      );
    },

    print_doc() {
      // Simplemente imprimir la imagen que ya se generó
      if (!this.invoiceImg) {
        console.warn("No hay imagen de documento para imprimir");
        return;
      }

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);

      const htmlContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Print Document</title>
            <style>
              body { margin: 0; padding: 10px; }
              img { max-width: 100%; }
            </style>
          </head>
          <body>
            <img src="${this.invoiceImg}" width="100%">
          </body>
        </html>
      `;

      iframe.contentDocument.write(htmlContent);
      iframe.contentDocument.close();

      setTimeout(() => {
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 500);
      }, 800);
    },

    send_invoice(uuid) {
      var company = this.item.company;
      if (this.item.buyer && this.item.buyer.PartyEmail) {
        this.loading_mail = true;
        var qry = {
          nit: company.PartyIdentification,
          environment: parseInt(company.environment),
          uuid: uuid,
          data: { to: [{ email: this.item.buyer.PartyEmail }] },
          store: this.item.document.store,
        };
        console.log("📧 Enviando correo:", qry);
        fe_ws("send_invoice", qry, (data) => {
          this.loading_mail = false;
          console.log("📧 Respuesta envío correo:", data);
          this.mail_response = data;
          
          // Mostrar notificación
          if (data && data.status_description) {
            const isSuccess = data.status_description.toLowerCase().includes('success') || 
                             data.status_description.toLowerCase().includes('exitoso');
            this.$store.commit("setSnackbar", {
              text: data.status_description || "Correo enviado",
              color: isSuccess ? "success" : "warning",
              timeout: 4000,
            });
          }
          
          // Opcionalmente mostrar diálogo con detalles
          // this.dialog_mail = true;
        });
      } else {
        console.warn("⚠️ No hay email del comprador para enviar");
        this.$store.commit("setSnackbar", {
          text: "No hay correo electrónico del cliente",
          color: "warning",
          timeout: 3000,
        });
      }
    },

    create_nc() {
      var dnc = { ...this.item };
      dnc.items = this.selected;
      var total = 0;
      dnc.items.forEach((itm) => {
        total += parseFloat(itm.item_quantity) * parseFloat(itm.item_price);
      });

      dnc.payments = [
        {
          payment_code: "99",
          payment_concept: "NOTA CREDITO",
          payment_reference: "",
          payment_value: -total,
        },
      ];

      dnc.document.doc_value = total;
      var doc = {
        store: this.item.document.store,
        data: dnc,
      };
      console.log("create_nc", doc);

      webserver("post_note", doc, (data) => {
        // console.log("create_nc", data);
        //this.nc_dialog = false;
        this.$emit("refresh", data);
        this.nc_dialog = false;
      });
    },

    e_credit_note(e) {
      // console.log("🔍 Procesando nota de crédito electrónica:", e);

      const doc = e.document;
      const itms = e.items;
      const company = this.item.company;

      // ❌ PROBLEMA: Manejo de fecha sin validación
      if (!doc.issuedate_reference) {
        console.error("❌ Error: No hay fecha de referencia en el documento");
        return;
      }

      const IssueDTA = doc.issuedate_reference.split(" ")[0];

      // ❌ PROBLEMA: Acceso directo sin validación
      if (!doc.invoice || !doc.cufe) {
        console.error("❌ Error: Documento no tiene factura de referencia o CUFE");
        return;
      }

      // ❌ PROBLEMA: Hardcoded values en resolution
      const eInv = {
        discrepancy_response: {
          correction_concept_id: 2, // Corrección por devolución de bienes
        },
        billing_reference: {
          number: doc.invoice.replace("-", ""),
          uuid: doc.cufe,
          issue_date: IssueDTA,
        },
        number: doc.doc_number.split("-")[2],
        resolution: {
          prefix: doc.doc_number.split("-")[0],
          from: 1, // ❌ HARDCODED: Debería venir de f_consecutive
          to: 10000, // ❌ HARDCODED: Debería venir de f_consecutive
        },
        sync: true,
        environment: { type_environment_id: parseInt(company.environment) },
        type_document_id: 5, // Nota de crédito
        customer: {
          identification_number: doc.PartyIdentification,
          name: doc.PartyName,
          municipality_id: doc.city_code || e.company.city_code,
          email: doc.PartyEmail,
        },
        legal_monetary_totals: {
          line_extension_amount: 0,
          tax_exclusive_amount: 0,
          tax_inclusive_amount: 0,
          allowance_total_amount: 0,
          charge_total_amount: 0,
          payable_amount: 0,
        },
        credit_note_lines: [],
      };

      // ✅ CAMBIO: Procesamiento de items con IVA dinámico
      itms.forEach((item) => {
        item.item_quantity = parseFloat(item.item_quantity);

        // ✅ OBTENER IVA DEL ITEM
        const itemTaxRate = parseFloat(item.taxes) || 0; // Porcentaje de IVA del item
        const tax_multiplier = 1 + itemTaxRate / 100; // 1.19 para 19%, 1.05 para 5%, etc.

        // NO redondear aquí - mantener precisión para cálculos
        item.price_amount = parseFloat(item.item_price) / tax_multiplier;
        item.discount = (parseFloat(item.item_discount) / tax_multiplier) * item.item_quantity;
        // Calcular line_extension_amount primero (sin redondear)
        item.line_extension_amount = item.price_amount * item.item_quantity;
        // Calcular tax sobre el line_extension_amount (sin redondear)
        item.tax = (item.line_extension_amount * itemTaxRate) / 100;
        // Guardar el porcentaje de IVA para usar después
        item.tax_rate = itemTaxRate;
      });

      // ✅ CORRECTO: Construcción de líneas de nota de crédito
      itms.forEach((item) => {
        // CRÍTICO: Redondear line_extension_amount PRIMERO
        const roundedLineExtension = Math.round(item.line_extension_amount);
        const roundedPriceAmount = Math.round(item.price_amount);
        const roundedDiscount = Math.round(item.discount);
        
        // LUEGO calcular tax sobre el line_extension_amount REDONDEADO
        const roundedTax = Math.round((roundedLineExtension * item.tax_rate) / 100);
        
        const itm = {
          description: item.item_concept,
          unit_measure_id: 642, // ❌ HARDCODED: Debería ser configurable
          code: item.item_code,
          type_item_identification_id: 3, // ❌ HARDCODED
          base_quantity: item.item_quantity.toFixed(6),
          invoiced_quantity: item.item_quantity.toFixed(6),
          price_amount: roundedPriceAmount,
          line_extension_amount: roundedLineExtension,
        };

        // Manejo de descuentos
        if (item.item_discount > 0) {
          const baseAmount = (item.price_amount + (item.item_discount / item.item_quantity)) * item.item_quantity;
          itm.allowance_charges = [
            {
              charge_indicator: false,
              allowance_charge_reason: "Discount",
              amount: roundedDiscount,
              base_amount: Math.round(baseAmount),
            },
          ];
          eInv.legal_monetary_totals.allowance_total_amount += roundedDiscount;
        }

        // ✅ CONFIGURACIÓN DE IMPUESTOS CON IVA DINÁMICO
        itm.tax_totals = [
          {
            tax_id: 1, // ❌ HARDCODED: IVA
            tax_amount: roundedTax,
            taxable_amount: roundedLineExtension,
            percent: Math.round(item.tax_rate), // ✅ USAR IVA DEL ITEM
          },
        ];

        // Acumulación de totales
        eInv.legal_monetary_totals.line_extension_amount += roundedLineExtension;
        eInv.legal_monetary_totals.tax_exclusive_amount += roundedLineExtension;
        eInv.legal_monetary_totals.tax_inclusive_amount += roundedLineExtension + roundedTax;
        eInv.legal_monetary_totals.charge_total_amount += roundedLineExtension + roundedTax;
        eInv.legal_monetary_totals.payable_amount += roundedLineExtension + roundedTax;
        eInv.credit_note_lines.push(itm);
      });

      // Formatear totales finales
      Object.keys(eInv.legal_monetary_totals).forEach((key) => {
        eInv.legal_monetary_totals[key] = parseFloat(
          eInv.legal_monetary_totals[key]
        ).toFixed(2);
      });

      console.log("📄 Nota de crédito preparada:", eInv);

      this.put_credit_note(eInv);
    },

    put_credit_note(data) {
      this.loading_status = true;
      var qry = {
        method: "POST",
        nit: window.store.store_business_id,
        data: data,
        store: this.item.document.store,
        issueDate: this.item.document.issuedate,
        did: this.item.document.doc_number,
      };
      this.loading_status = true;
      console.log("put_credit_note", qry);
      fe_ws("post_credit_note", qry, (data) => {
        this.loading_status = false;
        console.log("put_credit_note response", data);
        const response = JSON.parse(data.data);
        if (response.is_valid) {
          console.log("✅ Nota de crédito enviada exitosamente:", data);

          // ✅ ACTUALIZAR DOCUMENTO CON DATOS DE DIAN
          if (response && response.uuid) {
            console.log("📤 Documento actualizado con CUDE:", this.item.document.cufe);
            this.nc_success = true; // ← ACTIVA SNACKBAR DE ÉXITO
            // 🔄 REGENERAR IMAGEN CON NUEVO CUDE
            this.regenerateImageWithCUFE();
          }

          this.$emit("refresh", data); // ← EMITE EVENTO AL COMPONENTE PADRE
          this.nc_dialog = false; // ← CIERRA EL DIÁLOGO
        } else {
          // ❌ MANEJO DE ERRORES MEJORADO
          console.error("❌ Error enviando nota de crédito:", data.error);
        }
      });
    },

    /**
     * 🇨🇴 Reenviar documento a DIAN (para botones manuales)
     */
    async resendToDIAN() {
      if (!this.item || !this.item.document) {
        alert("⚠️ No hay documento para reenviar");
        return;
      }

      console.log("🔄 Reenviando documento a DIAN...");
      this.showDianProcessing = true;
      this.dianProcessingMessage = "Enviando a DIAN...";

      DIANService.resendDocument(this.item, (result) => {
        this.showDianProcessing = false;

        if (result.success) {
          console.log("✅ Documento reenviado exitosamente");

          // Actualizar item con datos de DIAN
          if (result.document_updated) {
            Object.assign(this.item.document, result.document_updated);
            console.log("📤 Item actualizado con CUFE:", this.item.document.cufe);

            // Regenerar imagen con CUFE
            this.regenerateImageWithCUFE();
          }

          // Mostrar notificación de éxito
          this.$store.commit("setSnackbar", {
            text: `✅ Documento enviado a DIAN exitosamente`,
            color: "success",
            timeout: 3000,
          });
        } else {
          console.error("❌ Error reenviando documento:", result.error);

          // Mostrar errores específicos de DIAN
          this.showDianErrors(result);
        }
      });
    },

    async processColombiaDocumentIfNeeded(documentData) {
      // ✅ LOGGING: Validar estado del reseteo
      console.log("🔍 VALIDACIÓN RESETEO - Estado inicial:", {
        newInvoice: this.newInvoice,
        docType: documentData.document?.doc_type,
        hasCUFE: !!documentData.document?.cufe,
        docNumber: documentData.document?.doc_number,
      });

      // Solo procesar si es documento nuevo (newInvoice = true)
      if (!this.newInvoice) {
        console.log("📄 Documento existente, no procesar DIAN");
        return;
      }

      // Solo procesar tipos DIAN específicos
      const dianTypes = ["FE"];
      if (!dianTypes.includes(documentData.document?.doc_type)) {
        console.log("📄 Tipo de documento no requiere procesamiento DIAN");
        return;
      }

      // Verificar si ya tiene CUFE (ya procesado)
      if (documentData.document?.cufe) {
        console.log("📄 Documento ya tiene CUFE, omitir procesamiento");
        console.log("⚠️ POSIBLE PROBLEMA: Documento nuevo con CUFE existente");
        return;
      }

      console.log("🇨🇴 Procesando automáticamente documento DIAN...");
      console.log("✅ RESETEO CORRECTO: Nuevo documento sin CUFE");

      this.showDianProcessing = true;
      this.dianProcessingMessage = "Procesando con DIAN...";

      return new Promise((resolve) => {
        DIANService.processDocument(documentData, (result) => {
          if (result.success) {
            console.log("✅ Documento procesado automáticamente en DIAN");

            // PUNTO CRÍTICO: ¿Se actualiza correctamente el item?
            if (result.document_updated) {
              Object.assign(this.item.document, result.document_updated);
              console.log(
                "📤 Item actualizado localmente con CUFE:",
                this.item.document.cufe
              );
              console.log("✅ CUFE ASIGNADO CORRECTAMENTE para próximo reseteo");

              // 🔄 REGENERAR IMAGEN CON CUFE
              this.regenerateImageWithCUFE();
            } else {
              this.showDianProcessing = false;
            }
          } else {
            this.showDianProcessing = false;
            console.error("❌ Error procesando documento DIAN:", result.error);

            // Mostrar errores de DIAN como notificaciones
            this.showDianErrors(result);
          }

          resolve(result);
        });
      });
    },

    /**
     * 📋 Mostrar errores de DIAN como notificaciones
     */
    showDianErrors(result) {
      console.log("🔍 Analizando errores DIAN:", result);

      // Verificar si hay errores específicos de DIAN
      const dianData = result.data || result.dian_response;

      if (
        dianData &&
        dianData.errors_messages &&
        Array.isArray(dianData.errors_messages)
      ) {
        console.log("📋 Errores encontrados:", dianData.errors_messages);

        // Mostrar un alert consolidado con todos los errores
        const allErrors = dianData.errors_messages.join("\n\n");
        const statusMessage =
          dianData.status_message || dianData.status_description || "";

        alert(
          `❌ ERRORES DIAN:\n\n${allErrors}\n\n${
            statusMessage ? `Estado: ${statusMessage}` : ""
          }`
        );
      } else {
        // Error genérico si no hay detalles específicos
        console.log("❌ Error genérico:", result.error);
        alert(`❌ Error enviando a DIAN: ${result.error}`);
      }
    },

    async regenerateImageWithCUFE() {
      try {
        console.log("🔄 Regenerando imagen con CUFE actualizado...");

        // Cambiar mensaje del overlay
        this.dianProcessingMessage = "Actualizando documento con CUFE...";

        // Regenerar imagen colombiana con el item actualizado
        this.imageSrc = await generateColombiaPrint(this.item);
        this.invoiceImg = this.imageSrc;

        // Ocultar overlay
        this.showDianProcessing = false;

        console.log("✅ Imagen regenerada con CUFE:", this.item.document.cufe);

        // Mostrar notificación de éxito
        this.$store.commit("setSnackbar", {
          text: `✅ Documento procesado en DIAN con CUFE`,
          color: "success",
          timeout: 3000,
        });
      } catch (error) {
        this.showDianProcessing = false;
        console.error("❌ Error regenerando imagen con CUFE:", error);

        this.$store.commit("setSnackbar", {
          text: "❌ Error actualizando documento",
          color: "error",
          timeout: 3000,
        });
      }
    },

    processToDIAN() {
      this.showDianProcessing = true;
      this.dianProcessingMessage = "Procesando documento en DIAN...";

      // Simular llamada a servicio DIAN
      const timestamp = this.item.document.issuedate; // Replace with your actual timestamp string
      const [date] = timestamp.split(/\s+/);
      var invoice = {
        did: this.item.document.doc_number,
        pos_issueDate: date,
        store: this.item.document.store,
        doc_type: this.item.document.doc_type,
      };

      this.loading_status = true;
      webserver("post_invoice_complete_contingencia", invoice, (data) => {
        this.showDianProcessing = false;
        // this.item = data;
        if (data.document.invoice) {
          this.e_invoice_fe_C(data);
        }
      });
    },
    e_invoice_fe_C(data) {
      var custumer = data.buyer;
      var itms = data.items;
      var doc = data.document;
      var company = data.company;
      var resolution = data.permit.InvoiceAuthorization;
      var syncCode = true;

      if (company.sync_code === "1") {
        syncCode = true;
      } else {
        syncCode = false;
      }

      // type_organization se determina por el tipo local antes de mapear.
      // Persona Jurídica solo si es NIT (en cualquiera de sus formas).
      var rawType = String(custumer.PartyTypeId || "").trim().toUpperCase();
      var type_organization = rawType === "NIT" || rawType === "6" ? 1 : 2;

      // Resolver al id del catálogo DIAN (entero). El API espera el id, no el code ni el string local.
      custumer.PartyTypeId = resolveDianDocTypeId(custumer.PartyTypeId, type_organization);

      const timestamp = this.item.document.issuedate; // Replace with your actual timestamp string
      const [date, time] = timestamp.split(/\s+/);

      var eInv = {
        number: doc.invoice.split("-")[1],
        sync: syncCode,
        type_document_id: 3,
        date: date,
        time: time,
        additional_document_references: [
          {
            number: doc.invoice,
          },
        ],

        branch_office: {
          name: this.item.company.PartyName,
          phone: this.item.company.client_phone,
          address: this.item.company.AddressLine,
          trade_name: this.item.company.PartyName,
          municipality_id: this.item.company.city_code,
        },
        customer: {
          type_document_identification_id: custumer.PartyTypeId,
          identification_number: custumer.PartyIdentification,
          type_organization_id: type_organization,
          name: custumer.PartyName,
          address: custumer.AddressLine,
          municipality_id: custumer.municipality_id,
          email: custumer.PartyEmail,
        },
        legal_monetary_totals: {
          line_extension_amount: 0,
          tax_exclusive_amount: 0,
          tax_inclusive_amount: 0,
          allowance_total_amount: 0,
          charge_total_amount: 0,
          payable_amount: 0,
        },
        invoice_lines: [],
      };

      itms.forEach((item) => {
        item.item_quantity = parseFloat(item.item_quantity);
        // CAMBIO: Usar el impuesto real del item
        const itemTaxRate = parseFloat(item.item_tax) || 0;
        const tax_value_dynamic = 1 + itemTaxRate / 100;
        // NO redondear aquí - mantener precisión para cálculos
        item.price_amount = parseFloat(item.item_price) / tax_value_dynamic;
        item.item_discount = parseFloat(item.item_discount);
        // Calcular line_extension_amount primero (sin redondear)
        item.line_extension_amount = item.price_amount * item.item_quantity;
        // Calcular tax sobre el line_extension_amount (sin redondear)
        item.tax = (item.line_extension_amount * itemTaxRate) / 100;
        // Guardar tax rate para uso posterior
        item.taxRate = itemTaxRate;
      });

      itms.forEach((item) => {
        if (item.item_quantity > 0) {
          // CRÍTICO: Redondear line_extension_amount PRIMERO
          const roundedLineExtension = Math.round(item.line_extension_amount);
          const roundedPriceAmount = Math.round(item.price_amount);
          const taxRate = Math.round(item.taxRate);
          
          // LUEGO calcular tax sobre el line_extension_amount REDONDEADO
          const roundedTax = Math.round((roundedLineExtension * taxRate) / 100);
          
          var itm = {
            description: item.item_concept,
            unit_measure_id: 938,
            code: item.item_code,
            type_item_identification_id: 3,
            base_quantity: item.item_quantity.toFixed(6),
            invoiced_quantity: item.item_quantity.toFixed(6),
            price_amount: roundedPriceAmount,
            line_extension_amount: roundedLineExtension,
          };
          
          if (roundedLineExtension == 0) {
            itm.reference_price_id = 1;
            itm.price_amount = Math.round(item.item_discount);
          }
          
          if (item.item_discount > 0) {
            const discountAmount = item.item_discount * item.item_quantity;
            itm.allowance_charges = [
              {
                charge_indicator: false,
                allowance_charge_reason: "Discount",
                amount: Math.round(discountAmount),
                base_amount: Math.round((item.price_amount + item.item_discount) * item.item_quantity),
              },
            ];
            eInv.legal_monetary_totals.allowance_total_amount += Math.round(discountAmount);
          }

          itm.tax_totals = [
            {
              tax_id: taxRate == 8 ? 4 : 1,
              tax_amount: roundedTax,
              taxable_amount: roundedLineExtension,
              percent: taxRate,
            },
          ];

          eInv.legal_monetary_totals.line_extension_amount += roundedLineExtension;
          eInv.legal_monetary_totals.tax_exclusive_amount += roundedLineExtension;
          eInv.legal_monetary_totals.tax_inclusive_amount += roundedLineExtension + roundedTax;
          eInv.legal_monetary_totals.charge_total_amount += roundedLineExtension + roundedTax;
          eInv.legal_monetary_totals.payable_amount += roundedLineExtension + roundedTax;
          eInv.invoice_lines.push(itm);
        }
      });

      var payments = this.item.payments;
      var bags = payments.find((item) => item.tipo === "ICB ley 1819 de 2016");
      if (bags) {
        bags.quantity = parseFloat(bags.valor) / 66;
        bags.tax = 66;
        var itmBags = {
          description: "Bolsas",
          unit_measure_id: 886,
          code: "000000000000",
          type_item_identification_id: 3,
          base_quantity: "1.000000",
          invoiced_quantity: bags.quantity.toFixed(6),
          price_amount: parseFloat(bags.valor).toFixed(2),
          line_extension_amount: "0.00",
          reference_price_id: 1,
          tax_totals: [
            {
              tax_id: 10,
              tax_amount: parseFloat(bags.valor).toFixed(2),
              taxable_amount: parseFloat(bags.quantity).toFixed(2),
              unit_measure_id: 886,
              per_unit_amount: bags.tax.toFixed(2),
              base_unit_measure: bags.quantity.toFixed(6),
            },
          ],
          //  parseFloat(bags.quantity).toFixed(2),
        };
        //
        eInv.legal_monetary_totals.line_extension_amount += parseFloat(
          itmBags.line_extension_amount
        ); //Valores totales aplicables a la factura
        eInv.legal_monetary_totals.tax_exclusive_amount += parseFloat(
          itmBags.line_extension_amount
        ); // Total Valor Bruto (Antes de tributos)
        eInv.legal_monetary_totals.tax_inclusive_amount +=
          parseFloat(itmBags.line_extension_amount) + parseFloat(bags.valor);
        eInv.legal_monetary_totals.charge_total_amount +=
          parseFloat(itmBags.line_extension_amount) + parseFloat(bags.valor);
        eInv.legal_monetary_totals.payable_amount +=
          parseFloat(itmBags.line_extension_amount) + parseFloat(bags.valor);
        eInv.invoice_lines.push(itmBags);
      }

      eInv.legal_monetary_totals.line_extension_amount = eInv.legal_monetary_totals.line_extension_amount.toFixed(
        2
      ); //Valores totales aplicables a la factura
      eInv.legal_monetary_totals.tax_exclusive_amount = eInv.legal_monetary_totals.tax_exclusive_amount.toFixed(
        2
      ); // Total Valor Bruto (Antes de tributos)
      eInv.legal_monetary_totals.tax_inclusive_amount = eInv.legal_monetary_totals.tax_inclusive_amount.toFixed(
        2
      );
      eInv.legal_monetary_totals.allowance_total_amount = eInv.legal_monetary_totals.allowance_total_amount.toFixed(
        2
      );
      eInv.legal_monetary_totals.charge_total_amount = eInv.legal_monetary_totals.charge_total_amount.toFixed(
        2
      );
      eInv.legal_monetary_totals.payable_amount = eInv.legal_monetary_totals.payable_amount.toFixed(
        2
      );

      this.put_invoice_c(eInv, company, resolution);
    },
    async put_invoice_c(data, company, resolution) {
      // Validar que company y resolution existan
      // console.log("put_invoice_c - data:", data);
      // console.log("put_invoice_c - company:", company);
      // console.log("put_invoice_c - resolution:", resolution);
      this.showDianProcessing = true;
      var qry = {
        method: "POST",
        nit: company.PartyIdentification,
        environment: parseInt(company.environment),
        data: data,
        store: company.store_code,
        issueDate: this.item.document.issuedate,
        did: this.item.document.doc_number,
        resolution: resolution,
      };
      fe_ws("post_invoice_c", qry, async (dat) => {
        this.showDianProcessing = false;
        console.log("put_invoice_c response", dat);
        
        // Verificar si hubo errores
        if (dat && dat.data && dat.data.errors) {
          console.error("❌ Error en DIAN:", dat.data.errors);
          this.$store.commit("setSnackbar", {
            text: "Error al procesar en DIAN",
            color: "error",
            timeout: 5000,
          });
        } else {
          // Registro exitoso - actualizar CUFE y enviar correo automáticamente
          if (dat && dat.cufe) {
            this.item.document.cufe = dat.cufe;
            console.log("✅ CUFE recibido:", dat.cufe);
            
            // Enviar correo automáticamente
            this.send_invoice(dat.cufe);
          }
        }
        
        try {
          this.imageSrc = await generateColombiaPrint(data);
          this.invoiceImg = this.imageSrc;
        } catch (error) {
          console.error("❌ Error generando imagen:", error);
        }
        this.$emit("refresh", true);
        this.$emit("close", true);
      });
    },
  },

  watch: {
    dialog: {
      handler(newVal) {
        this.internalDialog = newVal;
      },
      immediate: true,
    },
    internalDialog(newVal) {
      if (newVal !== this.dialog) {
        this.$emit("input", newVal);
      }
    },
    item: async function (e) {
      if (!e || !e.document) return;

      // ✅ LOGGING: Validar estado del item que llega
      console.log("📄 Procesando documento DIAN (Colombia):", {
        docType: e.document.doc_type,
        docNumber: e.document.doc_number,
        hasCUFE: !!e.document.cufe,
        newInvoice: this.newInvoice,
        timestamp: new Date().toLocaleTimeString(),
      });

      // 1. Generar imagen colombiana (siempre, ya que es versión DIAN única)
      try {
        console.log("🇨🇴 Generando documento colombiano");
        this.imageSrc = await generateColombiaPrint(e);
        this.invoiceImg = this.imageSrc;
        console.log("✅ Imagen generada para Colombia ====>>>", e);

        // 2. Procesar automáticamente con DIAN si es documento nuevo
        await this.processColombiaDocumentIfNeeded(e);
      } catch (error) {
        console.error("❌ Error generando imagen:", error);
        this.$store.commit("setSnackbar", {
          text: "Error al generar el documento",
          color: "error",
          timeout: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
.navigation-drawer {
  display: flex;
  flex-direction: column;
  height: 90vh;
  position: fixed;
  top: 5vh;
  right: 0;
  z-index: 1000;
}

.document-viewer {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.document-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 0;
  max-height: 100%;
}

.document-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  max-width: 100%;
  object-fit: contain;
}

.fixed-footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media (max-width: 599px) {
  .document-content {
    padding: 4px;
  }

  .navigation-drawer {
    height: 95vh;
    top: 2.5vh;
    width: 100% !important;
  }
}
</style>
